import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Image } from "antd";
import styles from "../../styles/dashboard.module.scss";
import EngagementBar from "../../components/EngagementBar";
import StackedBarHappiness from "../../components/StackedBarHappiness";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";

export default function Engagement() {
  const { getUserByID } = useB2BContext();

  const [engagementData, setEngagementData] = useState<any[]>([]);
  const [engagementPercentage, setEngagementPercentage] = useState<any>();

  useEffect(() => {
    const year: any = moment().format("yyyy");
    if (getUserByID) {
      authSVC
        .yearlyEngagementIndexes({
          department_id: "",
          year: Number(year),
        })
        .then((res) => {
          setEngagementData(res?.data?.data);
          setEngagementPercentage(res?.data);
          console.log(res?.data, "01 000");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  return (
    <div className={styles.white_bg_wrapper}>
      <div className={styles.info_title}>
        <div className={styles.title_grp}>
          <Text className={styles.title}>Engagement</Text>
        </div>
        <div className={styles.title_grp1}>
          <Image
            className={styles.img}
            src="/img/new/download_icon.svg"
            preview={false}
          />
          <Text className={styles.subtitle1}>
            {engagementPercentage?.percentage}% from last month
          </Text>
        </div>
        <div className={styles.graph}>
          {engagementData?.length === 0 ? (
            <div className="no_data_yet">
              <img src="/img/User_empty.png" alt="" width="56" height="52" />
              <p>No data yet</p>
            </div>
          ) : (
            <EngagementBar chartData={engagementData} />
          )}
        </div>
      </div>
    </div>
  );
}
